import { Box } from "@mui/material";
import React, { memo } from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Link } from "react-router-dom";
import styles from "../../../styles/pages/analyticseditor.module.scss";
import styles2 from "../../../styles/pages/home.module.scss";
import { emptyHandleTwo } from "../../../lib/functions/utils.lib";

const AllSubmissions = ({ data, handleOpenSubmissionModal }) => {
  return (
    <>
      <Box
        className={`${styles.analyticBoxFour} ${styles.commonSmallBoxWrapperAnalytic}`}
        >
        <Box className="commonSmallBox commonSmallBoxAnalytics analyticBoxFour">
          <Box className={styles2.commonSmallBox}>
            <Box className={styles2.infoTable}>
              <Box className={styles2.infoTable_head}>
                <Link href="">
                  <Box className={styles2.tble_hdng}>All Submissions</Box>
                  <Box className={styles2.tble_hdng}>
                    {emptyHandleTwo(data?.all_submissions?.total)}
                  </Box>
                </Link>
              </Box>

              <Box className={styles2.infoTble_body}>
                <Box className={styles2.infoTble_row}>
                  <Link to="/approved">
                    <Box className={styles2.infoTble_cell}>Approved</Box>
                    <Box className={styles2.infoTble_cell}>
                      {emptyHandleTwo(data?.all_submissions?.approved)}
                    </Box>
                  </Link>
                </Box>
                <Box className={styles2.infoTble_row}>
                  <Link to="/rejected">
                    <Box className={styles2.infoTble_cell}>Rejected</Box>
                    <Box className={styles2.infoTble_cell}>
                      {emptyHandleTwo(data?.all_submissions?.rejected)}
                    </Box>
                  </Link>
                </Box>
                <Box className={styles2.infoTble_row}>
                  <Link to="/website">
                    <Box className={styles2.infoTble_cell}>Website Only</Box>
                    <Box className={styles2.infoTble_cell}>
                      {emptyHandleTwo(data?.all_submissions?.website_only)}
                    </Box>
                  </Link>
                </Box>
                <Box className={styles2.infoTble_row}>
                  <Link to="/duplications">
                    <Box className={styles2.infoTble_cell}>Duplicates</Box>
                    <Box className={styles2.infoTble_cell}>
                      {emptyHandleTwo(data?.all_submissions.duplicate_videos)}
                    </Box>
                  </Link>
                </Box>
                <Box className={styles2.infoTble_row}>
                  <Link to="/pending">
                    <Box className={styles2.infoTble_cell}>Pending</Box>
                    <Box className={styles2.infoTble_cell}>
                      {emptyHandleTwo(data?.all_submissions.pending)}
                    </Box>
                  </Link>
                </Box>
                <Box
                  className={styles2.infoTble_row}
                  onClick={handleOpenSubmissionModal} 
                >
                  <Link href="">
                    <Box className={styles2.infoTble_cell}>
                      Unreachable Submitters 
                    </Box>
                    <Box className={styles2.infoTble_cell}>
                      {emptyHandleTwo(data?.all_submissions?.unreachable_submitters)}
                    </Box>
                  </Link>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default memo(AllSubmissions);
